import {
  get, patch, post,
} from './helper';

export async function checkIdentification(identification) {
  const res = await get({
    url: `team/exists/?identification=${identification}`,
  });
  return res?.data || res;
}

export async function checkResetPwdToken(token) {
  const res = await get({
    url: `email/confirm_reset_password?confirmation_token=${token}`,
    version: 0,
  });
  return res?.data || res;
}

export async function login(data) {
  const res = await post({
    url: 'user/sign_in_v2',
    data,
    version: 0,
  });
  return res?.data || res;
}

export async function register(data) {
  const res = await post({
    url: 'user/sign_up_v2',
    data,
    version: 0,
  });
  return res?.data || res;
}

export async function resendVerifyEmail(email) {
  const res = await post({
    url: 'user/resend_verify_email',
    data: { email },
    version: 0,
  });
  return res?.data || res;
}

export async function sendForgetPasswordLink(email) {
  const res = await post({
    url: 'user/forget_password',
    data: { email },
    version: 0,
  });
  return res?.data || res;
}

export async function sendResetPasswordLink(data) {
  const res = await post({
    url: 'user/reset_password',
    data,
    version: 0,
  });
  return res?.data || res;
}

export async function updateUser(data) {
  const res = await patch({
    url: 'user',
    data,
    version: 0,
  });
  return res?.data || res;
}

export async function getUserInfo() {
  const res = await get({
    url: 'admin/members/me',
  });
  return res?.data || res;
}

export async function getUserRole() {
  const res = get({
    url: 'admin/members/role',
  });
  return res?.data || res;
}

export async function resetPasswordWithToken(token) {
  const res = await post({
    url: 'email/verify_v2',
    data: {
      confirmation_token: token,
    },
    version: 0,
  });
  return res?.data || res;
}

export default {
  checkResetPwdToken,
  getUserInfo,
  getUserRole,
  login,
  register,
  resendVerifyEmail,
  resetPasswordWithToken,
  sendForgetPasswordLink,
  sendResetPasswordLink,
  updateUser,
};
